import Vue from "vue";
import CompanyService from "@/service/CompanyService";
import MenuRightSerivce from "@/service/MenuRightService";
import SweetAlertService from "@/service/SweetAlertService";
import StaffService from "@/service/StaffService";
import StaffEmploymentService from "@/service/StaffEmploymentService";
import StoreGetter from "@/constants/StoreGetter";
import { PayGroup } from "@/model/PayGroup";
import t from "@/service/SysMsgService";
import dictEnum from "@/constants/SysMsgDict";
import Setting from "@/constants/Settings";
import PayGroupService from "@/service/PayGroupService";
import payGroupValidation from "./S082000-PayGroupValidation.js";
import Paginate from "vuejs-paginate";
import PayTypeService from "../../../service/PayTypeService.js";
import PayMethodService from "../../../service/PayMethodService.js";
import moment from "moment";
var payGroupObj = new payGroupValidation();
export default {
    name: "payGroup",
    mounted() {
        payGroupObj.payGroupValidation();
        this.assignRights();
        this.getPayTypeList();
        this.getPayMethodList();
        this.getAllPayGroup();
    },
    components: {
        paginate: Paginate,
    },
    data: () => ({
        menuRights: { allRights: {}, rightsForThisMenu: {} },
        menuId: Setting.MenuID.S_PayGroup,
        dictEnum: dictEnum,
        payGroup: new PayGroup(),
        isEditMode: false,
        payGroupList: [],
        selectedPayGroupModel: new PayGroup(),
        payTypeList: [],
        payMethodList: [],
        selectAllPayGroup: false,
        currentPage: 1,
        perPage: 15,
        fields: [
            {
                key: "Grp",
                label: t.t(dictEnum.LBL_PayGroup)
            },
            {
                key: "GrpDesc",
                label: t.t(dictEnum.LBL_PayGroupDesc)
            },
            {
                key: "PayTypeCode",
                label: t.t(dictEnum.LBL_PayType)
            },
            {
                key: "PayMethodCode",
                label: t.t(dictEnum.LBL_PayMethod)
            },
            {
                key: "StartDay",
                label: t.t(dictEnum.LBL_PayrollStartDay)
            },
            {
                key: "ValueDay",
                label: t.t(dictEnum.LBL_PayrollDefaultDay)
            },
            {
                key: "Action",
                label: ""
            },
        ],
    }),
    computed: {
        t() {
            return t;
        },
        user() {
            return this.$store.getters[StoreGetter.user];
        },
    },
    methods: {
        hasRight(key, menuId) {
            if (Object.keys(this.menuRights.allRights).length === 0) {
                return false;
            } else {
                return MenuRightSerivce.hasRightInMenu(
                    this.menuRights.allRights,
                    menuId ? menuId : this.menuId,
                    key
                );
            }
        },
        assignRights() {
            this.menuRights.allRights = this.$store.getters[StoreGetter.sysMenu];
            this.menuRights.rightsForThisMenu = this.menuRights.allRights.find(
                x => x.MenuID == this.menuId
            );
        },

        async getPayTypeList() {
            var obj = {}
            const response = await PayTypeService.getAllPayType(obj);
            if (response.data.IsSuccess) {
                this.payTypeList = response.data.Data;
            } else {
                SweetAlertService.warning("Warn", response.data.Message);
            }
        },

        async getPayMethodList() {
            var obj = {};
            const response = await PayMethodService.getAllPayMethod(obj);
            if (response.data.IsSuccess) {
                this.payMethodList = response.data.Data;
            } else {
                SweetAlertService.warning("Warn", response.data.Message);
            }
        },

        rowClass(item, type) {
            if (!item || type !== 'row') return
            if (this.selectedPayGroupModel.Grp == item.Grp) {
                return 'selected-tr'
            }
        },

        async getAllPayGroup() {
            var obj = {}
            const response = await PayGroupService.getAllPayGroup(obj);
            if (response.data.IsSuccess) {
                this.payGroupList = response.data.Data;
            } else {
                SweetAlertService.warning("Warn", response.data.Message);
            }
        },
        selectAllPayGroupRecord: function () {
            var IsSelected = this.selectAllPayGroup;
            this.payGroupList.forEach(function (val, index) {
                val["isSelected"] = IsSelected;
            });
        },
        deleteMultiplePayGroupPopup: function () {
            var arrayList = [];
            if (this.selectedPayGroupModel) {
                $('#deletePayGroupListModel').modal('show');
            }
            else {
                SweetAlertService.warning("Warn", this.t.t(dictEnum.MSG_SelectDeleteRecord));
            }
        },
        async deleteMultiplePayGroup() {
            var arrayList = [];
            $('#deletePayGroupListModel').modal('hide');
            var obj = {
                model: {
                    Grp: this.selectedPayGroupModel.Grp,
                    GrpDesc: this.selectedPayGroupModel.GrpDesc,
                    PayTypeCode: this.selectedPayGroupModel.PayTypeCode,
                    PayMethodCode: this.selectedPayGroupModel.PayMethodCode,
                    StartDay: this.selectedPayGroupModel.StartDay,
                    ValueDay: this.selectedPayGroupModel.ValueDay,
                }
            }
            const response = await PayGroupService.deletePayGroup(obj);
            if (response.data.IsSuccess) {
                SweetAlertService.success("Success", response.data.Message);
                this.resetPayGroup();
                await this.getAllPayGroup();
            } else {
                SweetAlertService.warning("Warn", response.data.Message);
            }
        },
        OnPayGroupSelect: function (model) {
            this.selectedPayGroupModel = model;
        },
        addPayGroup: function () {
            $('#payGroupModel').modal('show');
            this.isEditMode = false;
            this.payGroup = new PayGroup();
            this.$validator.reset();
            this.vErrors.clear();
        },
        async savePayGroupDetail(obj) {
            const response = await PayGroupService.addPayGroup(obj);
            if (response.data.IsSuccess) {
                SweetAlertService.success("Success", response.data.Message);
                this.resetPayGroup();
                await this.getAllPayGroup();
            } else {
                SweetAlertService.warning("Warn", response.data.Message);
            }
        },
        async editPayGroup(obj) {
            const response = await PayGroupService.updatePayGroup(obj);
            if (response.data.IsSuccess) {
                SweetAlertService.success("Success", response.data.Message);
                this.resetPayGroup();
                await this.getAllPayGroup();
            } else {
                SweetAlertService.warning("Warn", response.data.Message);
            }
        },
        async savePayGroup() {
            var self = this;
            self.$validator.validateAll().then(result => {
                if (result) {
                    $('#payGroupModel').modal('hide');
                    const obj = {
                        model: {
                            Grp: self.payGroup.Grp,
                            GrpDesc: self.payGroup.GrpDesc,
                            PayTypeCode: self.payGroup.PayTypeCode,
                            PayMethodCode: self.payGroup.PayMethodCode,
                            StartDay: self.payGroup.StartDay,
                            ValueDay: self.payGroup.ValueDay,
                            DateAdd: self.payGroup.DateAdd,
                            AddBy: self.payGroup.AddBy,
                            DateModify: moment().format(Setting.DateTime.yyyymmdd),
                            ModifyBy: self.user.UserID,
                            RecDel: false
                        }
                    };
                    if (self.isEditMode) {
                        self.editPayGroup(obj);
                    }
                    else {
                        self.savePayGroupDetail(obj);
                    }
                }
            });
        },
        async editPayGroupDetail() {
            this.isEditMode = true;
            if (this.selectedPayGroupModel.Grp != "") {
                this.payGroup = this.selectedPayGroupModel;
                this.$validator.reset();
                this.vErrors.clear();
                $('#payGroupModel').modal('show');
            }
            else {
                SweetAlertService.warning("Warn", this.t.t(dictEnum.MSG_SelectEditRecord));
            }
        },
        resetPayGroup: function () {
            this.selectAllPayGroup = false;
            this.isEditMode = false;
            this.payGroup = new PayGroup();
            this.selectedPayGroupModel = new PayGroup();
            this.$validator.reset();
            this.vErrors.clear();
        },
        closePayGroupPopup: function () {
            this.selectAllPayGroup = false;
            this.isEditMode = false;
            this.payGroup = new PayGroup();
            this.selectedPayGroupModel = new PayGroup();
            this.$validator.reset();
            this.vErrors.clear();
            $('#payGroupModel').modal('hide');
        },
    }
}



// WEBPACK FOOTER //
// ./src/components/S080000-Setup/S082000-PayGroup/S082000-PayGroup.js